/*
 * Copyright (c) 2024. Amazon.com, Inc. or its affiliates. All rights reserved.
 */

import type { DeviceInfo } from '@amzn/vinyl-amzn'
import type { CodeData } from '@amzn/vinyl-amzn/cbl'
import { getUserAgentInfo, lazy, type Lazy } from '@amazon/vinyl-util'
import { getDeviceInfo } from '@/device/device'

export function createCodeData(deviceInfo: DeviceInfo): CodeData {
    const uA = getUserAgentInfo()
    return {
        app_name: 'WebCP',
        app_version: '1.0.0',
        device_model: 'Vinyl Test',
        device_serial: deviceInfo.deviceId,
        device_name: deviceInfo.deviceName,
        device_type: deviceInfo.deviceType,
        domain: 'Device',
        os_version: `${uA.os?.name} ${uA.os?.version?.str}`,
    }
}

const codeDataRef: Lazy<CodeData> = lazy(() => {
    return createCodeData(getDeviceInfo())
})

export function getCodeData(): CodeData {
    return codeDataRef.value
}
